$(function () {

    let slider = $(".pdp-zoom .gallery-content");
    let sliderOpenDiv = $(".pdp-immagine-prodotto");
    let sliderWrap = $(".pdp-zoom");
    let nextArrow = $(".gallery-arrow-next");
    let prevArrow =  $(".gallery-arrow-prev");
    let closeBtn = $(".close-gallery");
    let arrowOut = $(".arrow-out-zoom");
    let currentSlideContainer = $('.gallery-image-wrp.slick-current');

    sliderOpenDiv.on("click", function () {
        var imagePosition = $(this).attr('data-pos');
        sliderWrap.removeClass("hidden");
        slider.slick({
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            draggable:false,
            swipe:false,
            touchMove:false,
            prevArrow: prevArrow,
            nextArrow: nextArrow
        })

        if(imagePosition > 1){
            slider.slick('slickGoTo', (imagePosition-1));
        }

        hide();

        closeBtn.on("click", function (evt) {
            chiudiGallery();
            currentSlideContainer.trigger('zoom.destroy');
        });

        initZoom();
    });

/*     arrowOut.on("click", function (evt) {
        currentSlideContainer.trigger('zoom.destroy');
        initZoom();
        console.log('init test')
    }); */


    slider.on('beforeChange', function(event, slick, currentSlide){
        initZoom();
    });

    slider.on('afterChange', function(event, slick, currentSlide){
        initZoom();
        currentSlideContainer.trigger('zoom.destroy');
    });  

    function initZoom() {
        const currentSlide = $('.gallery-image-wrp.slick-current');
        currentSlide.zoom({
            url: $(this).find('img').attr('data-zoom'),
            callback: function(){
                const imgH = currentSlide.find('.zoomImg').height() / 2
                const imgW = currentSlide.find('.zoomImg').width() / 2
                const marginTop = 'calc(50vh - ' + imgH + 'px)'
                const marginLeft = 'calc(50vw - ' + imgW + 'px)'
                if(window.matchMedia("(min-width: 769px)").matches) {
                    currentSlide.find('.zoomImg').css({'top': marginTop, 'left': marginLeft }).trigger('mouseover')
                }
            },
            onZoomIn: function() {
                currentSlide.find('.image-to-zoom').css('opacity', '0')
            },
            onZoomOut: function() {
                currentSlide.find('.image-to-zoom').css('opacity', '1')
            }
        });   
    }

    function hide(){
        $("body").css("overflow-y", "hidden");
        $(".wrp-header").addClass("hidden");
        $(".add-to-cart-buttons").addClass("hidden");
        $(".showcolor-btn-desktop").addClass("hidden");
    }

    function chiudiGallery () {
        $('.pdp-zoom .gallery-content').slick('unslick');
        $(".pdp-zoom").addClass("hidden");
        $("body").css("overflow-y", "auto");
        $(".wrp-header").removeClass("hidden");
        $(".add-to-cart-buttons").removeClass("hidden");
        //$(".showcolor-btn-desktop").removeClass("hidden");
    }

/*     function arrowZoomOut () {
        console.log('ok')
    } */

});
